import React, { useState, useCallback, useEffect } from "react";
import { GoogleReCaptcha, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import Layout from "../layout/layout";
import "./contact.css";

const Contact = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [successmsg, setSuccessMsg] = useState(false);
  const [errormsg, setErrorMsg] = useState(false);
  const [formValue, setformValue] = React.useState({
    email: "",
    name: "",
    phoneNumber: "",
    message: "",
  });
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // store the states in the form data
    let payload = {
      ...formValue,
    };

    try {
      setLoading(true);
      const captchaToken = await executeRecaptcha("login");
      const customHeaders = {
        "x-recaptcha-token": captchaToken,
      };
      // make axios post request
      const response = await axios.post(
        "http://localhost:3000/forms/contact",

        payload,
        customHeaders
      );

      if (response.status) {
        setSuccessMsg(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setErrorMsg(true);
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setformValue({
      ...formValue,
      [event.target.name]: event.target.value,
    });
  };

  const setTokenFunc = useCallback((getToken) => {
    setRecaptchaToken(getToken);
  }, []);
  console.log("value", recaptchaToken?.slice(0, 10));

  useEffect(() => {
    if (!loading) {
      setRefreshReCaptcha(false);
    }
  }, [loading]);

  return (
    <Layout>
      <div className="contact-page">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-form">
              <div className="contact-form-content">
                <h2>צור קשר</h2>
                <p>אנחנו כאן בשביל לעזור.</p>
                <p>מוזמנים להשאיר הודעה ונחזור אליכם בהקדם האפשרי :-)</p>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="firstname-form">
                    <Form.Label>שם פרטי *</Form.Label>
                    <Form.Control
                      name="firstname"
                      type="text"
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group className="lastname-form">
                    <Form.Label>שם משפחה *</Form.Label>
                    <Form.Control
                      name="lastname"
                      type="text"
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="form-group">
                    <Form.Label>אימייל *</Form.Label>
                    <Form.Control
                      name="email"
                      type="email"
                      value={formValue.phoneNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="form-group">
                    <Form.Label>טלפון</Form.Label>
                    <Form.Control
                      name="phoneNumber"
                      type="tel"
                      value={formValue.phoneNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-3 form-group"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>תוכן ההודעה *</Form.Label>
                    <Form.Control as="textarea" rows={3} />
                  </Form.Group>
                </Form>
                <GoogleReCaptcha
                  onVerify={setTokenFunc}
                  refreshReCaptcha={refreshReCaptcha}
                />
                <div className="send-btn">
                  <Button variant="primary" type="submit">
                    שליחה
                  </Button>
                </div>

                {successmsg && (
                  <div className="success-msg">Form submitted successFully</div>
                )}

                {errormsg && (
                  <div className="error-msg">
                    Please fill all the fields correctly
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
